var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 612,
    viewBox: "0 0 1920 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1599_1729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 612
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 612,
    fill: "#F5F3F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1599_1729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1951.87 254.72L1951.87 -76.2547C1951.92 -110.378 1942.97 -143.913 1925.93 -173.477C1908.89 -203.042 1884.36 -227.592 1854.81 -244.654L1567.99 -410.142C1538.48 -427.179 1505.01 -436.149 1470.93 -436.149C1436.86 -436.149 1403.38 -427.179 1373.87 -410.142L1087.06 -244.654C1057.51 -227.592 1032.98 -203.042 1015.94 -173.477C998.895 -143.913 989.95 -110.378 990 -76.2546L990 254.72C990.035 288.762 999.021 322.196 1016.06 351.668C1033.09 381.14 1057.58 405.614 1087.06 422.634L1373.87 588.122C1403.38 605.159 1436.86 614.129 1470.93 614.129C1505.01 614.129 1538.48 605.159 1567.99 588.122L1854.81 420.208C1883.93 403.395 1908.19 379.303 1925.21 350.293C1942.22 321.282 1951.41 288.349 1951.87 254.72Z",
    fill: "black",
    fillOpacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.5 133.92L2155.5 -197.055C2155.55 -231.178 2146.61 -264.712 2129.57 -294.277C2112.53 -323.842 2087.99 -348.392 2058.44 -365.454L1771.63 -530.941C1742.12 -547.979 1708.64 -556.949 1674.57 -556.949C1640.49 -556.949 1607.02 -547.979 1577.51 -530.941L1290.7 -365.454C1261.14 -348.392 1236.61 -323.842 1219.57 -294.277C1202.53 -264.712 1193.59 -231.178 1193.64 -197.054L1193.64 133.921C1193.67 167.962 1202.66 201.396 1219.69 230.868C1236.73 260.34 1261.22 284.814 1290.7 301.835L1577.51 467.322C1607.02 484.36 1640.49 493.329 1674.57 493.329C1708.64 493.329 1742.12 484.36 1771.63 467.322L2058.44 299.408C2087.57 282.595 2111.83 258.503 2128.85 229.493C2145.86 200.482 2155.05 167.549 2155.5 133.92Z",
    fill: "black",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.55 -4.13132L2400.55 -335.106C2400.6 -369.23 2391.66 -402.764 2374.61 -432.329C2357.57 -461.893 2333.04 -486.444 2303.49 -503.506L2016.68 -668.993C1987.17 -686.031 1953.69 -695 1919.62 -695C1885.54 -695 1852.07 -686.031 1822.56 -668.993L1535.74 -503.506C1506.19 -486.444 1481.66 -461.893 1464.62 -432.329C1447.58 -402.764 1438.63 -369.23 1438.68 -335.106L1438.68 -4.13123C1438.72 29.9102 1447.71 63.344 1464.74 92.816C1481.78 122.288 1506.26 146.762 1535.74 163.783L1822.56 329.27C1852.07 346.308 1885.54 355.277 1919.62 355.277C1953.69 355.277 1987.17 346.308 2016.68 329.27L2303.49 161.356C2332.62 144.543 2356.88 120.451 2373.89 91.441C2390.91 62.4307 2400.09 29.4975 2400.55 -4.13132Z",
    fill: "black",
    fillOpacity: 0.03
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBig);
export default __webpack_public_path__ + "static/media/bg-big.011d9a34fce7d014a9b561ac6fabbbf1.svg";
export { ForwardRef as ReactComponent };